// Booking forms only get categories that have items (see the backend's BookableCatalogue).
// A saved booking can still point at a category/item that is no longer offered: an old line
// where a category was sold as the item itself, or an item whose category was switched off.
// Add those saved selections back as options (flagged `saved`) so editing shows and keeps them.

const isCatalogueId = (v) => v !== "" && v !== null && v !== undefined && Number(v) > 0;

export const withSavedSelections = (list, lines) => {
  const options = [...(list || [])];
  const has = (id) => options.some((o) => o?.id === id);

  (lines || []).forEach((line) => {
    const categoryId = line?.category_id;
    if (!isCatalogueId(categoryId)) return;
    const name = line?.item_name || "";

    if (line?.is_item) {
      // Saved item titles are "Category- Item"
      const sep = name.indexOf("- ");
      if (!has(categoryId)) options.push({ id: categoryId, parent_id: 0, title: sep > -1 ? name.slice(0, sep) : name, saved: true });
      if (isCatalogueId(line?.item_id) && !has(line.item_id)) options.push({ id: line.item_id, parent_id: categoryId, title: sep > -1 ? name.slice(sep + 2) : name, saved: true });
    } else if (!has(categoryId)) {
      options.push({ id: categoryId, parent_id: 0, title: name, saved: true });
    }
  });

  return options;
};

// Categories a booking line may pick: ones with items, plus any saved on this booking
export const isOfferedCategory = (options, val) =>
  val?.parent_id === 0 && (val?.saved || options.some((c) => c?.parent_id === val?.id));
